import styled from 'styled-components';

export const ModalTitle = styled.h3`
  font-size: 2rem;
  padding: 0;
  margin-bottom: 0.5em;
  margin-top: 0;
  text-align: center;
`;
